























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import PurchaseItemModel from "@/usecases/orders/purchase-item";
import PurchaseRow from "./PurchaseRow.vue";
import VTd from "./VTd.vue";
import SelectOption from "../../../common/ui/presenters/select-option";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    VTd,
    PurchaseRow
  }
})
export default class PurchaseItem extends Vue {
  @Prop({ required: true }) item!: PurchaseItemModel;
  @Prop({ default: () => [] }) unitOptions!: SelectOption[];
  @Prop({ required: true }) level!: number;
  @Prop({ required: true }) index!: number;

  change() {
    this.$emit("change");
  }

  emitPreview(e: Event) {
    const target = (e.target as any) || null;
    let el:
      | HTMLInputElement
      | HTMLSelectElement
      | HTMLTextAreaElement
      | null = null;
    if (target && typeof target.closest === "function") {
      el = target.closest("input,select,textarea");
    }

    let value = "";
    if (el) {
      const anyEl: any = el as any;
      if (anyEl.type === "checkbox") {
        return;
      }
      if (anyEl.value != null) {
        value = String(anyEl.value);
      }
    }

    this.$emit("preview", { value });
  }

  get isDiscountRow(): boolean {
    return (
      this.item.estimateItemId === "" || Number(this.item.estimateItemId) === 0
    );
  }

  isNegative(value: number): boolean {
    return value < 0;
  }
}
